<template>
<section>
    <el-row>
      		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
     <h3  style="color: rgb(102, 102, 102); text-align: center; margin-top: 2em;">
        {{title}}
        <!---->
        <el-tag type="success"   size="medium " >报名</el-tag>
        <!-- <span type="success" style="font-size: 0.5em; font-weight: 400;">报名中</span> -->
        <!---->
    </h3>
    <h4 style="color: rgb(102, 102, 102); text-align: center; margin-top: 2em;">
      <el-button size="width:100%; height:100%;"  type="warning" >下载规程与资料</el-button>
	        <el-button size="width:100%; height:100%;" v-on:click="ExportReport"  type="primary" >下载报名表</el-button>

     </h4>
             </el-col>      
    </el-row>

     <el-row>
            <el-col :span="4" class="bj" >
               <el-table  :data="ServiceList" max-height="440" >
             	<el-table-column  label="赛事报名" style="width:100%" align="center">   
                     <template slot-scope="scope" >
                    <el-button
                      @click.native.prevent="columnClick(scope)"
                    type="text"
                   size="small">
                     {{ scope.row.Name}}
                   </el-button>
                  
                 </template>  
		        </el-table-column>
                </el-table>
              <div class="xinxitj"></div>            
              <el-table  max-height="440" >
             	<el-table-column  label="赛事服务" style="width:100%" align="center">   
                     <template slot-scope="scope" >
                   <el-tooltip class="item" effect="dark" content="" placement="left">
                    <el-button
                      @click.native.prevent=""
                    type="text"
                   size="small">
                      tttt
                   </el-button>
                    </el-tooltip>
                 </template>  
		        </el-table-column>
                </el-table>                
            </el-col>   
		<el-col :span="20"  style="margin-left:0px">
            <div v-show='togglePlayer'>
		   <el-col :span="24"  class="toolbar" style="padding-bottom: 0px;" >            
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>		
                <el-form-item  style="float:right;">
					<el-button size="width:100%; height:100%;"  type="danger" v-on:click="playerAdd" icon="el-icon-search">新报运动员</el-button>
				</el-form-item>							
                <el-form-item  style="float:right;">
					<el-button size="width:100%; height:100%;"  type="primary" v-on:click="getPlayerList" icon="el-icon-search">查询</el-button>
				</el-form-item>	
				<el-form-item>
					<el-input  v-model="filters.Name"  @keyup.enter.native="getPlayerList" placeholder="运动员名称"></el-input>
				</el-form-item>		
			</el-form>

           </el-col>
 		<!--列表-->
		<el-table  :data="PlayerList" highlight-current-row v-loading="Loading"  >
			<el-table-column  label="证照" width="120" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="right" effect="light">
  				 <img v-if="scope.row.ImageUrl!=null"  @click="see(scope.row.ImageUrl)"  :src="scope.row.ImageUrl" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >

                    </el-tooltip>
				</template>				
			</el-table-column>
            <el-table-column prop="Name" label="姓名" width="120" sortable>
			</el-table-column>
           <el-table-column prop="FullNname" label="拼音全称" width="120" sortable>
			</el-table-column>
           <el-table-column prop="IDNumber" label="证件号码" width="180" sortable>
			</el-table-column>
           <el-table-column prop="Birthday" label="生日" width="120" :formatter="formatDate" sortable>
			</el-table-column>
           <el-table-column prop="Unit" label="分计单位" width="120"  sortable>
			</el-table-column>			
           <el-table-column prop="Coache" label="教练" width="120"  sortable>
			</el-table-column>

			<el-table-column prop="CompetitionGroupName" label="赛事组名" width="120" sortable>
			</el-table-column>
			<el-table-column prop="CompetitionGroupItemName" label="比赛项目" width="200" sortable>
			</el-table-column>
			<el-table-column prop="CompetitionPostureName" label="泳姿名称" width="120" sortable>
			</el-table-column>
			<el-table-column prop="Distance" label="距离" width="120" sortable>
			</el-table-column>
           <el-table-column prop="Achievement" label="成绩" width="120"  sortable>
			</el-table-column>			
			<el-table-column prop="Test" label="测验" width="120" sortable>
			   		<template slot-scope="scope">			
                      <el-tag type="success"  v-if="scope.row.Test==1" size="small" >是</el-tag>
                      <el-tag type="danger"  v-if="scope.row.Test==0" size="small" >否</el-tag>
			   		</template>				
			</el-table-column>	
			<el-table-column prop="SpecialMark" label="特标" width="120" sortable>
			   		<template slot-scope="scope">			
                      <el-tag type="success"  v-if="scope.row.SpecialMark==1" size="small" >是</el-tag>
                      <el-tag type="danger"  v-if="scope.row.SpecialMark==0" size="small" >否</el-tag>
			   		</template>
			</el-table-column>

            <el-table-column prop="CreationTime" label="报名时间" width="200" sortable>
			</el-table-column>
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
			<el-table-column label="操作" width="80" fixed="right">
				<template  slot-scope="scope">
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>                    
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-tag>当前共{{PlayerCount}}条记录</el-tag>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="PlayerCount" style="float:right;">
			</el-pagination>
		</el-col>             
           </div>
            <div v-show='toggleStaff'>
		   <el-col :span="24"  class="toolbar" style="padding-bottom: 0px;" >            
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>		
                <el-form-item  style="float:right;">
					<el-button size="width:100%; height:100%;"  type="danger"  v-on:click="staffAdd"  icon="el-icon-search">新报工作人员</el-button>
				</el-form-item>							
                <el-form-item  style="float:right;">
					<el-button size="width:100%; height:100%;"  type="primary" v-on:click="getStaffList" icon="el-icon-search">查询</el-button>
				</el-form-item>	
				<el-form-item>
					<el-input  v-model="filters.StaffName"  @keyup.enter.native="getStaffList" placeholder="工作人员名称"></el-input>
				</el-form-item>		
			</el-form>

           </el-col>
 		<!--列表-->
		<el-table  :data="StaffList" highlight-current-row v-loading="Loading"  >
            <el-table-column prop="Name" label="姓名" width="120" sortable>
			</el-table-column>
           <el-table-column prop="IDNumber" label="证件号码" width="180" sortable>
			</el-table-column>
           <el-table-column prop="Birthday" label="生日" width="120" :formatter="formatDate" sortable>
			</el-table-column>
           <el-table-column prop="IdentityName" label="身份" width="120" sortable>
			</el-table-column>				
           <el-table-column prop="PartTimer" label="是否兼任" width="120"  sortable>
			   		<template slot-scope="scope">			
                      <el-tag type="success"  v-if="scope.row.PartTimer==1" size="small" >是</el-tag>
                      <el-tag type="danger"  v-if="scope.row.PartTimer==0" size="small" >否</el-tag>
			   		</template>
			</el-table-column>									
            <el-table-column prop="CreationTime" label="报名时间" width="200" sortable>
			</el-table-column>
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
			<el-table-column label="操作" width="200" fixed="right">
				<template  slot-scope="scope">
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>                    
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-tag>当前共{{StaffCount}}条记录</el-tag>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentStaffChange" :page-size="10" :total="StaffCount" style="float:right;">
			</el-pagination>
		</el-col> 	    
           </div>	
           <div v-show='toggleRelay'>
		   <el-col :span="24"  class="toolbar" style="padding-bottom: 0px;" >            
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>		
                <el-form-item  style="float:right;">
					<el-button size="width:100%; height:100%;"  type="danger"  v-on:click="relayAdd" icon="el-icon-search">新报接力</el-button>
				</el-form-item>							
                <el-form-item  style="float:right;">
					<el-button size="width:100%; height:100%;"  type="primary" v-on:click="getList" icon="el-icon-search">查询</el-button>
				</el-form-item>	
				<el-form-item>
					<el-input  v-model="filters.GroupName"  @keyup.enter.native="getList" placeholder="接力赛名称"></el-input>
				</el-form-item>		
			</el-form>

           </el-col>
 		<!--列表-->
		<el-table  :data="List" highlight-current-row v-loading="Loading"  >
            <el-table-column prop="CompetitionGroupName" label="组名" width="120" sortable>
			</el-table-column>
           <el-table-column prop="CompetitionGroupItemName" label="比赛项目" width="120" sortable>
			</el-table-column>
            <el-table-column prop="CreationTime" label="报名时间" width="200" sortable>
			</el-table-column>
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
			<el-table-column label="操作" width="200" fixed="right">
				<template  slot-scope="scope">
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>                    
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-tag>当前共{{Count}}条记录</el-tag>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange1" :page-size="10" :total="Count" style="float:right;">
			</el-pagination>
		</el-col> 	    
           </div>		  		   	   
		</el-col>
     </el-row>
	 <el-dialog title="接力赛报名" v-model="RelayVisible" :close-on-click-modal="false">
		 <div v-show="RelayEntry">
		   <el-col :span="24"  class="toolbar" style="padding-bottom: 0px;" >            
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>							
				<el-form-item  style="float:right;">
                <el-select  v-model="filters.GroupId" clearable filterable placeholder="选择赛事分组" style="width:400px" @change="relaySelectChange">
                <el-option 
                     v-for="item in GroupOptions"
                     :key="item.Id"
                     :label="item.Name"
                     :value="item.Id">
               </el-option>    			 
                   </el-select>	
				</el-form-item>	
			</el-form>
           </el-col>
		<el-table  :data="GroupItemTable" highlight-current-row v-loading="Loading"  style="width:1702px">		
			<el-table-column Prop="Select" label="勾选" width="80">
				<template slot-scope="scope">
                <el-checkbox v-model="scope.row.Select" ></el-checkbox>
                </template>
			</el-table-column>	
			<el-table-column prop="GroupItemName" label="项目名称" width="200" sortable>
			</el-table-column>         
			<el-table-column prop="Achievement" label="报名成绩" width="120"  sortable>
				<template slot-scope="scope">
				<el-input v-model="scope.row.Achievement"  ></el-input>
                </template>
			</el-table-column>
			<el-table-column prop="AchievementRemake" label="报名备注" min-width="180" sortable>
				<template slot-scope="scope">
                <el-input v-model="scope.row.AchievementRemake" ></el-input>
                </template>				
			</el-table-column>			
		</el-table>
			<div slot="footer" class="dialog-footer" style="float:right">
				</br>
				<el-button @click.native="cancelRelay">取消</el-button>
				<el-button type="primary" @click.native="entryRelay">提交</el-button>
				</br>
				</br>
			</div>			   					   			  
		 </div>
	 </el-dialog>
     <el-dialog title="工作人员报名" v-model="StaffVisible" :close-on-click-modal="false">
		 <div    v-show='StaffEntry'>
		<el-table  :data="StaffEntryList" highlight-current-row v-loading="Loading"  >		
			<el-table-column prop="Name" label="姓名" width="120" sortable>
			</el-table-column>         
 			<el-table-column prop="Sex" label="性别" width="100"  :formatter="formatSex" sortable>
			</el-table-column>	           
			<el-table-column prop="Phone" label="联系号码" width="150"  sortable>
			</el-table-column>
			<el-table-column prop="IdentityEnum" label="本队职务" :formatter="formatStaffType" width="240"  sortable>
			</el-table-column>	
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>					
			<el-table-column label="操作" width="80" fixed="right">
				<template  slot-scope="scope">
					<el-button type="danger" size="small" @click="handleStaffSelect(scope.row)">选择</el-button>
				</template>
			</el-table-column>			
		</el-table>			 
		 </div>
		 <div v-show="StaffFromVisible">
			 <el-form :model="SelectStaffRow" label-width="100px"  ref="StaffFrom">
				<el-form-item label="证件号码" prop="IDnumber">
					<el-input v-model="SelectStaffRow.IDnumber" :disabled="true"></el-input>
				</el-form-item>	
				<el-form-item label="姓名" prop="Name">
					<el-input v-model="SelectStaffRow.Name" :disabled="true"></el-input>
				</el-form-item>	
				<el-form-item label="手机号码" prop="Phone">
					<el-input v-model="SelectStaffRow.Phone" ></el-input>
				</el-form-item>									
				<el-form-item label="性别" prop="Sex">
					<el-input v-model="SelectStaffRow.Sex==0?'女':'男'"    :disabled="true" ></el-input>
				</el-form-item>	
				<el-form-item label="出生日期" prop="Birthday">
					<el-input v-model=" SelectStaffRow.Birthday"  :disabled="true" ></el-input>
				</el-form-item>	
				<el-form-item label="担任职务" prop="IdentityEnum">
						<el-radio-group v-model="SelectStaffRow.IdentityEnum">
						<el-radio class="radio" :label="0">领队</el-radio>
						<el-radio class="radio" :label="1">教练</el-radio>
						<el-radio class="radio" :label="2">医生</el-radio>
						<el-radio class="radio" :label="3">裁判</el-radio>
						<el-radio class="radio" :label="4">工作人员</el-radio>
					</el-radio-group>
				</el-form-item>						
				<el-form-item label="备注">
					<el-input type="textarea" v-model="SelectStaffRow.Remark"></el-input>
				</el-form-item>	  										 
			 </el-form>
			 	<div slot="footer" class="dialog-footer" style="float:right">
				</br>
				<el-button @click.native="staffAdd">取消</el-button>
				<el-button type="primary" @click.native="entryStaff">提交</el-button>
				</br>
				</br>
			</div>	
		 </div>
	 </el-dialog>
	 <el-dialog title="运动员报名" v-model="PlayerVisible" :close-on-click-modal="false">
		 <el-steps :active="PlayerActive" finish-status="success"  align-center >
              <el-step title="第1步" description="选择/添加运动员"style="width:47%"></el-step>
              <el-step title="第2步" description="确认/修改信息"style="width:47%"></el-step>
              <el-step title="第3步" description="赛事报名" style="width:10%"></el-step>
         </el-steps>
		 <div style="text-align:center"   v-show='PlayerEntry'>
		 <el-button type="warning" style="margin-top: 12px;" @click="selectPlayer">选择已添加运动员</el-button>
		 </div>
         <div v-show='PlayerListEntry'>
		   <el-col :span="24"  class="toolbar" style="padding-bottom: 0px;" >            
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>							
                <el-form-item  style="float:right;">
					<el-button size="width:100%; height:100%;"  type="primary" v-on:click="getPlayer" icon="el-icon-search">查询</el-button>
				</el-form-item>	
				<el-form-item>
					<el-input  v-model="filters.EntryName"  @keyup.enter.native="getPlayer" placeholder="运动员名称"></el-input>
				</el-form-item>		
			</el-form>

           </el-col>			 
		<el-table  :data="PlayerEntryList" highlight-current-row v-loading="Loading"  style="width:1702px">		
			<el-table-column prop="Name" label="姓名" width="120" sortable>
			</el-table-column>         
			<el-table-column prop="LicenseNumber" label="证件号" width="240"  sortable>
			</el-table-column>
 			<el-table-column prop="Sex" label="性别" width="100"  :formatter="formatSex" sortable>
			</el-table-column>	           
			<el-table-column prop="Phone" label="联系号码" width="150"  sortable>
			</el-table-column>
			<el-table-column prop="Birthday" label="出生日期" min-width="180" :formatter="formatDate"  sortable>
			</el-table-column>				
			<el-table-column label="操作" width="80" fixed="right">
				<template  slot-scope="scope">
					<el-button type="danger" size="small" @click="handleSelect(scope.row)">选择</el-button>
				</template>
			</el-table-column>			
		</el-table>

		 </div>
		<div v-show='PlayerInfo'>
			
			<el-form :model="editForm" label-width="100px"  ref="editForm">
				</br>
				
				<div style="text-align:center">
					<el-tooltip content="点击查看大图" placement="left-end" effect="dark">
  				 <img   @click="see(editForm.ImageUrl)"  :src="editForm.ImageUrl" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >

                    </el-tooltip>
					
				</div>
				<div style="text-align:center">
             <el-upload :http-request="upload" action="">
             <!-- <i class="el-icon-upload"></i> -->
             <el-button size="small" type="primary">点击上传</el-button>
             <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
            </el-upload>
				</div>	
				</br>
			
				<el-form-item label="姓名全拼" prop="FullNname">
					<el-input v-model="editForm.FullNname" :disabled="true"></el-input>
				</el-form-item>	
				<el-form-item label="性别" prop="Sex">
					<el-input v-model="editForm.Sex==0?'女':'男'"    :disabled="true" ></el-input>
				</el-form-item>	
				<el-form-item label="出生日期" prop="Birthday">
					<el-input v-model=" editForm.Birthday"  :disabled="true" ></el-input>
				</el-form-item>					     
 				<el-form-item label="教练" prop="CompetitionTeamStaffId">
                  <el-select v-model="editForm.CompetitionTeamStaffId"  clearable placeholder="请选择教练" style="width:100%">
                <el-option 
                     v-for="item in coachOptions"
                     :key="item.Id"
                     :label="item.Name"
                     :value="item.Id">
               </el-option>                                                                            
                 </el-select>				
                 </el-form-item>                                           		  
				<el-form-item label="备注">
					<el-input type="textarea" v-model="editForm.Remark"></el-input>
				</el-form-item>	                                     
			</el-form>
			<div slot="footer" class="dialog-footer" style="float:right">
				<el-button @click.native="selectPlayer">取消</el-button>
				<el-button type="primary" @click.native="entryEditSubmit">提交</el-button>
				</br>
				</br>

			</div>	 
		 </div>
        <div v-show="GroupInfo">
		   <el-col :span="24"  class="toolbar" style="padding-bottom: 0px;" >            
			   <span style="float:left">{{editForm.Name}}  {{editForm.Sex==0?'女':'男'}}  {{editForm.LicenseNumber}}</span>					
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>		
									
				<el-form-item  style="float:right;">
                <el-select  v-model="filters.GroupId" clearable filterable placeholder="选择赛事分组" style="width:400px" @change="selectChange">
                <el-option 
                     v-for="item in GroupOptions"
                     :key="item.Id"
                     :label="item.Name+' '+(item.Sex==0?'女子':item.Sex==1?'男子':item.Sex==2?'男子女子':'未知')+' ('+item.AgeMin+'-'+item.AgeMax+')'"
                     :value="item.Id">
               </el-option>    			 
                   </el-select>	
				</el-form-item>	
			</el-form>
           </el-col>
		<el-table  :data="GroupItemTable" highlight-current-row v-loading="Loading"  style="width:1702px">		
			<el-table-column Prop="Select" label="勾选" width="80">
				<template slot-scope="scope">
                <el-checkbox v-model="scope.row.Select" ></el-checkbox>
                </template>
			</el-table-column>	
			<el-table-column prop="GroupItemName" label="项目名称" width="200" sortable>
			</el-table-column>         
			<el-table-column prop="Achievement" label="报名成绩" width="120"  sortable>
				<template slot-scope="scope">
				<el-input v-model="scope.row.Achievement"  ></el-input>
                </template>
			</el-table-column>
			<el-table-column prop="Test" label="测验" width="100"  sortable>
				<template slot-scope="scope">
                <el-checkbox v-model="scope.row.Test"></el-checkbox>
                </template>				
			</el-table-column>
			<el-table-column prop="SpecialMark" label="特标" width="100"  sortable>
				<template slot-scope="scope">
                <el-checkbox v-model="scope.row.SpecialMark"></el-checkbox>
                </template>
			</el-table-column>						
			<el-table-column prop="AchievementRemake" label="成绩说明" min-width="180" sortable>
				<template slot-scope="scope">
                <el-input v-model="scope.row.AchievementRemake" ></el-input>
                </template>				
			</el-table-column>			
		</el-table>
			<div slot="footer" class="dialog-footer" style="float:right">
				</br>
				<el-button @click.native="selectPlayer">取消</el-button>
				<el-button type="primary" @click.native="entryPlayer">提交</el-button>
				</br>
				</br>
			</div>			   			
		</div>


	 </el-dialog>
	         <el-dialog title="查看大图" v-model="seeImageVisible">
			<img   :src="imgUrl" style="height: 100%; width: 100%; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; ">
	 </el-dialog>
</section>

</template>
<script>
	import util from '../../common/js/util'
	import {mapGetters,mapMutations} from 'vuex';

	//import NProgress from 'nprogress'
	import {ExportEntryReport,EntryRelayInfo,GetListByRelay,GetListGroupByType, EntryStaff,EntryPlayerInfo,GetItemList,GroupList,UploadEntryImage,GetInfo,CompetitionEntryList,EntryList,getTeamPlayerList,getTeamStaffList ,CheckGroup,removeCompetitionEntry} from '../../api/api';

	export default {
		data() {
            return {
				RelayEntry:false,
                 RelayVisible:false,
				StaffFromVisible:false,		
				StaffEntry:false,
				StaffEntryList:[],
				StaffVisible:false,
                SelectStaffRow:{},
				GroupItemTable:[],
				GroupItemList:[],
                GroupOptions:[],
				GroupInfo:false,
				entryModel:{
					ImageId:'',
					CoachOptionsId:'',
					Remark:'',
					CompetitionId:'',
					PlayerId:'',					
					CompetitionTeamId:'',	
					CompetitionGroupId:'',
					StaffId:'',
					AchievementRemake:''				
				},
				imageId:'',
				CompetitionTeamId:'',
				Competition:{},
				editForm:{},
				coachOptions:[],
				PlayerListEntry:false,
				PlayerEntry:false,
				PlayerInfo:false,
				PlayerEntryList:[],
				PlayerActive: 1,
				PlayerVisible:false,
				StaffCount:0,
				StaffList:[],
                PlayerCount:0,
                PlayerList:[],
                togglePlayer:true,
                toggleStaff:false,
                toggleRelay:false,
				toggleVideo:false,
				imgUrl:'',
                seeImageVisible:false,
                ServiceList:[{'Flag':'Player','Name':'运动员'},
                {'Flag':'Staff','Name':'工作人员'},
                {'Flag':'Relay','Name':'接力'},
				// {'Flag':'Video','Name':'队伍视频'}
				],
                title:'2019-2020年游泳俱乐部大联盟联赛（福州站）',
				filters: {
					EntryName:'',
					Name: '',
					Type:'',
					StaffName:'',	
					GroupId:'',	
					GroupName:'',
					RelayGroupId:'',		
				},
				fit:'contain',
				Count:0,
				List:[],
				total: 0,
				page: 0,
				playpage:0,
				staffPage:0,
				Loading: false,
				sels: [],//列表选中列
			}
		},
methods: {
	    ExportReport(){
					   let para={
			   CompetitionId:this.Competition.Id
		   }
		   ExportEntryReport(para).then((res)=>{		
	   let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
	   var downloadElement = document.createElement('a');
var href = window.URL.createObjectURL(blob); //创建下载的链接
downloadElement.href = href;
downloadElement.download = '报名表'; //下载后文件名
document.body.appendChild(downloadElement);
downloadElement.click(); //点击下载
document.body.removeChild(downloadElement); //下载完成移除元素
window.URL.revokeObjectURL(href); //释放掉blob对象
		   })		   			
		},
	     cancelRelay(){
			this.RelayEntry=false;
			this.RelayVisible=false;			 
		 },
	     entryStaff(){
			    this.entryModel.AchievementRemake=this.SelectStaffRow.Remark;
			 	let para ={
						EntryModel:this.entryModel,
						
					   }
                     EntryStaff(para).then((res)=>{
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: Msg,
							type: 'success'
						});
						  this.StaffFromVisible=false;
						  this.StaffVisible=false;
						  this.getStaffList();
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}						 
					 })			 
		 },
	    handleStaffSelect(row){
			 this.SelectStaffRow=row;
			 this.entryModel.StaffId=row.Id;
			 this.StaffEntry=false;
			 this.StaffFromVisible=true;
			 
		},
		relayAdd(){
			this.RelayEntry=true;
			this.RelayVisible=true;
			this.GroupItemTable=[];
			this.GroupOptions=[];
			this.entryModel.CompetitionId=this.Competition.Id;
			this.entryModel.CompetitionTeamId=this.CompetitionTeamId;
			let para={CompetitionId:this.Competition.Id,
			  Type:1
			}			
			GetListGroupByType(para).then((res)=>{
				   this.GroupOptions=res.data.Data;
				    }).catch(error=>{
				   })
		},
	    staffAdd(){
			this.StaffVisible=true;
			this.StaffEntry=true;
			this.StaffFromVisible=false;
				let para={}
                  getTeamStaffList(para).then((res)=>{
				   this.StaffEntryList=res.data;
				    }).catch(error=>{
				   })	
			this.entryModel={
					ImageId:'',
					CoachOptionsId:'',
					Remark:'',
					CompetitionId:this.Competition.Id,
					PlayerId:'',					
					CompetitionTeamId:this.CompetitionTeamId,	
					CompetitionGroupId:'',
					StaffId:''				
				}   			
		},
		entryRelay(){
			// PlayerActive: 1,
			 let str=[];
			//  console.log("ttt");
			 this.GroupItemTable.forEach(item => {              
					   if(item.Select)
					   {
						   str.push(item);
					   }				   
			 }) 
			 	let para ={
						EntryModel:this.entryModel,
						EntryList:str,
					   }
                     EntryRelayInfo(para).then((res)=>{
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: Msg,
							type: 'success'
						});
						  this.RelayVisible=false;
						  this.RelayEntry=false;
						  this.getList();
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}						 
					 })				
		},
	    entryPlayer(){
			// PlayerActive: 1,
			 let str=[];
			//  console.log("ttt");
			 this.GroupItemTable.forEach(item => {              
					   if(item.Select)
					   {
						   str.push(item);
					   }				   
			 }) 
			 	let para ={
						EntryModel:this.entryModel,
						EntryList:str,
					   }
                     EntryPlayerInfo(para).then((res)=>{
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: Msg,
							type: 'success'
						});
						  this.PlayerVisible=false;
						  this.getPlayerList();
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}						 
					 })	
		},
	    selectEvent(event,index,row){
		},
	    relaySelectChange(event)
        { 
			this.entryModel.CompetitionGroupId=event;
			let para ={
						CompetitionGroupId:event,
						
					}
           GetListByRelay(para).then((res)=>{
			   this.GroupItemList=res.data.Data;
			   this.GroupItemTable=[];
			   			//  console.log("ttt2"); 
			  if(this.GroupItemList!=null)
			  {
			 this.GroupItemList.forEach(item => {              
					 let model={
						 Select:false,
						 CompetitionGroupItemId:item.Id,
					  CompetitionPostureId:item.CompetitionPostureId,
					  GroupItemName:item.Name,
					  Achievement:'99:99.99',
					  Test:false,
					  SpecialMark:false,
					  AchievementRemake:''
					 }
			   		 this.GroupItemTable.push(model);
			 }) 
			  }

					 })			        
        },		
	    selectChange(event)
        { 
			this.GroupItemList=[];
			this.entryModel.CompetitionGroupId=event;
			let para ={
						CompetitionGroupId:event,
						PlayerId:this.editForm.Id
					}
           GetItemList(para).then((res)=>{
			   this.GroupItemList=res.data.Data;
			   this.GroupItemTable=[];
			   			 console.log("ttt2");
			  if(this.GroupItemList!=null)
			  {
			 this.GroupItemList.forEach(item => {              
					 let model={
						 Select:false,
						 CompetitionGroupItemId:item.Id,
					  CompetitionPostureId:item.CompetitionPostureId,
					  GroupItemName:item.Name,
					  Achievement:'99:99.99',
					  Test:false,
					  SpecialMark:false,
					  AchievementRemake:''
					 }
			   		 this.GroupItemTable.push(model);
			 }) 
			  }

					 })			        
        },
	       entryEditSubmit(){
				this.PlayerInfo=false;
				this.GroupInfo=true;
            
			this.entryModel.ImageId=this.imageId;
			this.entryModel.CoachOptionsId=this.editForm.CompetitionTeamStaffId;
			this.entryModel.Remark=this.editForm.Remark;
			this.entryModel.CompetitionId=this.Competition.Id;
			this.entryModel.CompetitionTeamId=this.CompetitionTeamId;
			this.entryModel.PlayerId=this.editForm.Id;
				this.getGroupList();
			   this.next(3);
		   },
            upload(param){
			    var fileObj=param.file;
				var fd=new FormData();
				fd.append("file",fileObj);
			  	UploadEntryImage(fd).then((res)=>{
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '上传成功',
							type: 'success'
						});
						this.imageId=res.data.Data;
						 this.editForm.ImageUrl=res.data.ExtendData;
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}
		              
			  }).catch(error=>{
                 alert('网络错误');
                });                
            },	
		 ...mapGetters(['getcompetition']),		
		 ...mapGetters(['getuserstate']),
		 ...mapMutations(['Setcompetition']),

        //显示新增界面
	   getInfo:function(){
					let TenancyId=JSON.parse(this.getuserstate()).TenancyId;
					// console.log(localhoststoryid.storyid);
					let para ={
						TenancyId:TenancyId
					}
           GetInfo(para).then((res)=>{
				this.CompetitionTeamId=res.data.Data.Id;
				this.getPlayerList();
					 })
		 },
		 getGroupList(row){
				this.GroupItemTable=[];
				let para={
					id:this.editForm.Id,
				    competitioId:this.Competition.Id
				}
                  GroupList(para).then((res)=>{
						let { Success,Msg } = res.data;
                       this.GroupOptions=res.data.Data;
				    }).catch(error=>{
				   })				

			},
			handleSelect(row){

				let para={
					id:row.Id,
				    competitioId:this.Competition.Id
				}
                  CheckGroup(para).then((res)=>{
						let { Success,Msg } = res.data;
						if(Success)
						{
							this.editForm=res.data.Data;
			            	this.PlayerInfo=true;
			              	this.PlayerListEntry=false;
			             	this.next(2);
						}else
						{
					    	this.$message({
							message: Msg,
							type: 'error'
					    	});							
						}
				    //  this.coachOptions=res.data;
				    }).catch(error=>{
				   })				

			},
 			GetOptionList(){
				let para={IdentityEnum:1}
                  getTeamStaffList(para).then((res)=>{
				   this.coachOptions=res.data;
				    }).catch(error=>{
				   })					   				   
		    },  			
			selectPlayer(){
				this.PlayerListEntry=true;
				this.PlayerInfo=false;
				this.GroupInfo=false;
				this.filters.GroupId='';
				this.getPlayer();
				this.GetOptionList();
				this.next(1);
			},
			getPlayer(){
			   let para={
				   Name:this.filters.EntryName
			   }			   
			   	this.Loading = true;
				getTeamPlayerList(para).then((res) => {
					this.PlayerEntryList = res.data;
						this.Loading = false;
				})
				 .catch(error=>{
                 alert('网络错误');
                });	
			},
           next(value) {
			//    if (this.PlayerActive++ > 2) this.PlayerActive = 0;
			   this.PlayerActive=value;
			},	
			playerAdd(){
			   this.PlayerVisible=true;
			   this.PlayerEntry=true;
			   this.filters.EntryName='';
			   this.selectPlayer();
			},	
            handleCurrentChange1(val) {
				this.page = val;
				this.getList();
			},			
            handleCurrentChange(val) {
				console.log(val);
				console.log('js');
				this.playpage = val;
				this.getPlayerList();
			},
            handleCurrentStaffChange(val) {
				this.staffPage = val;
				// this.getPlayerList();
				this.getStaffList();
			},	
			getList(){
				let para = {
					PageIndex: this.Page-1,					
					PageSize:10,
					Name:this.filters.GroupName,
					Type:2,
					CompetitionTeamId:this.CompetitionTeamId,
					CompetitionId:this.Competition.Id
				};
				this.Loading = true;
				EntryList(para).then((res) => {
					this.Count = res.data.TotleCount;
					this.List =res.data.Data;
                    this.Count=res.data.TotleCount;
					this.Loading = false;
				})
				 .catch(error=>{
                 alert('网络错误');
                });	
			},		
			getStaffList(){
				let para = {
					PageIndex: this.staffPage-1,					
					PageSize:10,
					Name:this.filters.StaffName,
					Type:0,
					CompetitionTeamId:this.CompetitionTeamId,
                    CompetitionId:this.Competition.Id
				};
				this.Loading = true;
				EntryList(para).then((res) => {
					this.StaffCount = res.data.TotleCount;
					this.StaffList =res.data.Data;
                    this.StaffCount=res.data.TotleCount;
					this.Loading = false;
				})
				 .catch(error=>{
                 alert('网络错误');
                });				
			},
            getPlayerList(){
				let para = {
					PageIndex: this.playpage-1,					
					PageSize:10,
					Name:this.filters.Name,
					Type:1,
					CompetitionTeamId:this.CompetitionTeamId,
                    CompetitionId:this.Competition.Id
				};
				this.Loading = true;
				EntryList(para).then((res) => {
					this.PlayerCount = res.data.TotleCount;
					this.PlayerList =res.data.Data;
                    this.PlayerCount=res.data.TotleCount;
					this.Loading = false;
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.Loading = true;
					//NProgress.start();
					let para = { id: row.Id 					   
					};
					removeCompetitionEntry(para).then((res) => {
						this.Loading = false;
						//NProgress.done();
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						if(this.togglePlayer)
						{
						 this.getPlayerList();
						}
						if(this.toggleStaff)
						{
                         this.getStaffList();							
						}
						if(this.toggleRelay)
						{
                         this.getList();							
						}						
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}
					});
				}).catch(() => {
				});
			},
             columnClick(row){
                 
                   switch(row.row.Flag)
                   {
                       case 'Player':
                       {
                          this.togglePlayer=true;
                          this.toggleStaff=false;
                          this.toggleRelay=false;
						  this.toggleVideo=false;
						  this.getPlayerList();
                           break;
                        }
                        case 'Staff':
                       {
                           this.togglePlayer=false;
                          this.toggleStaff=true;
                          this.toggleRelay=false;
						  this.toggleVideo=false;   
						  this.getStaffList();                       
                           break;}
                       case 'Relay':
                       {
                           this.togglePlayer=false;
                          this.toggleStaff=false;
                          this.toggleRelay=true;
						  this.toggleVideo=false;    
						  this.getList();                         
                           break;}
                        case 'Video':
                       {break;}                                                                   
                   }
			 },
			see(imgUrl){
                     this.imgUrl=imgUrl;
                  this.seeImageVisible=true;
              },
			formatSex: function (row, column) {
				return row.Sex == 1 ? '男' : row.Sex == 0 ? '女' : row.Sex == 2?'混合':'未知';
			},
			formatType: function (row, column) {
  				return row.Type == 0 ? '普通组' : row.Type == 1 ? '接力组' : '未知';
                 
			},

			formatDate: function (row, column) {

				return util.formatDate.format(new Date(row.Birthday), 'yyyy-MM-dd');
						
			},
			formatState: function (row, column) {
				return row.State == 1 ? '暂停' : row.State == 0 ? '启用' : '未知';
			},
			// handleCurrentChange(val) {
			// 	console.log('getStaffList')

			// 	this.page = val;
			// 	this.getStaffList();
			// },

			getListData() {
				let para = {
					PageIndex: this.page-1,					
					PageSize:10,
					Name:this.filters.Name,
					Type:this.filters.Type,
				};
				this.Loading = true;
				CompetitionEntryList(para).then((res) => {
					this.total = res.data.TotleCount;
					this.List =res.data.Data;
                    this.Count=res.data.TotleCount;
					this.Loading = false;
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},				
			selsChange: function (sels) {
				this.sels = sels;
			},
			formatStaffType: function (row, column) {
				  if(row.IdentityEnum==0)
				 {
					 return '领队';
				 }else if(row.IdentityEnum==1)
				 {
					 return '教练';
				 }else if(row.IdentityEnum==2)
				 {
					 return '医生';
				 }else if(row.IdentityEnum==3)
				 {
					 return '裁判';
				 }else if(row.IdentityEnum==4)
				 {
					 return '工作人员';
				 }else
				 {
					 return '未知'
				 }
			},
   closeDialog(){
		this.inputIdCard="";
      this.onCellClick(event);
    },
   onCellClick(event)
   {
      this.$nextTick(function(){
         this.$refs['siteInput'].focus();
          // this.$(event.target).children().find("input").focus();
      })
   },
		},
		mounted() {
			 let model=JSON.parse(this.getcompetition());
			 this.Competition=model;
	         this.title=model.Name;
			this.getInfo();
						
			// this.getCount();
		},
		beforeMount(){			
			var model = sessionStorage.getItem('competition'); 
			  console.log(model);          
                //设置vuex用户状态
				 this.Setcompetition(model);				
		},
	}

</script>

<style scoped>
.xinxitj {
    font-size: 16px;
    line-height: 35px;
    border-bottom: solid 1px #c9cdd7;
    margin-bottom: 10px;
}
.bj{
    /* padding-top: 17px; */
padding-right: 10px;
padding-bottom: 45px;
/* padding-left: 16px; */
}
</style>


// WEBPACK FOOTER //
// Entry.vue?02972fe3